
document.addEventListener('DOMContentLoaded', function() {
  // Check if the current URL path matches the desired page URL
  if (window.location.pathname === '/pages/loyalty-program') {
    // Get the div by its ID and hide it
    var divToHide = document.getElementById('shopify-section-sections--20969237119313__rich_text_AeArFy');
    if (divToHide) {
      divToHide.style.display = 'none';
    }
  }
});


// Intercom hide on dropdown on mobile
document.addEventListener('DOMContentLoaded', function() {
  function isMobile() {
    return window.innerWidth <= 699; 
  }
  
  function getIntercomWidget() {
    return document.querySelector('.intercom-lightweight-app-launcher');
  }
  
  function hideWidget() {
    const widget = getIntercomWidget();
    if (widget && isMobile()) {
      widget.style.zIndex = '50';
      widget.style.opacity = '0.3';
      widget.style.pointerEvents = 'none';
      widget.style.transition = 'opacity 0.2s ease';
    }
  }
  
  function showWidget() {
    const widget = getIntercomWidget();
    if (widget && isMobile()) {
      widget.style.zIndex = '100';
      widget.style.opacity = '1';
      widget.style.pointerEvents = 'auto';
    }
  }
  
  // Hide widget when dropdowns/modals open (mobile only)
  document.addEventListener('click', function(e) {
    if (!isMobile()) return;
    
    const triggers = [
      '[data-popover-trigger]', 
      '[aria-haspopup]',
      '.js-modal-trigger',
      'select'
    ];
    
    if (triggers.some(selector => e.target.closest(selector))) {
      hideWidget();
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (!isMobile()) return;
    
    if (e.key === 'Escape') {
      showWidget();
    }
  });

  document.addEventListener('click', function(e) {
    if (!isMobile()) return;
    
    if (!e.target.closest('.modal, .popover, .dropdown')) {
      setTimeout(showWidget, 300);
    }
  });
  

  window.addEventListener('resize', function() {
    if (!isMobile()) {
      showWidget();
    }
  });
});
  
  // REMOVE BOTTOM SECTION MARGIN

  
document.addEventListener('DOMContentLoaded', function() {
    // Select all sections inside main except those with .shopify-section-group-footer-group
    var sections = document.querySelectorAll('main section:not(.shopify-section-group-footer-group)');
    if (sections.length > 0) {
        // Get the last section from the filtered list
        var lastSection = sections[sections.length - 1];
        console.log('Last section excluding .shopify-section-group-footer-group:', lastSection);

        // Then, check if the .section-spacing within that last section does not have .color-scheme--scheme-2
        var sectionSpacing = lastSection.querySelector('.section-spacing:not(.color-scheme--scheme-2)');
        console.log('.section-spacing within last section:', sectionSpacing);

        if (sectionSpacing !== null) {
            // Check if .section-spacing is NOT inside a .shopify-section--testimonials container
            if (sectionSpacing.closest('.shopify-section--testimonials') === null) {
                // Apply your changes to sectionSpacing
                sectionSpacing.style.paddingBlockEnd = '0vw';
            } else {
                console.log('.section-spacing is inside a .shopify-section--testimonials; no changes applied.');
            }
        } else {
            console.log('Last .section-spacing has .color-scheme--scheme-2 or not found; no changes applied.');
        }
    } else {
        console.log('No section found within main that excludes .shopify-section-group-footer-group');
    }
});








  // REMOVE CONTAINER


  
document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('#shopify-section-template--20969233613137__custom_liquid_NWdcTx');
  if (section) {
    var container = section.querySelector('.container');
    if (container) {
      container.classList.remove('container');
    }
  }
});



  // STOCKIST READ MORE SWAP


document.addEventListener("DOMContentLoaded", function() {
    // Check if current page is /blogs/stockist
    if(window.location.pathname === '/blogs/stockist') {
        // Select all buttons by their shared class
        var buttons = document.querySelectorAll('.blog-post-card__read-more');

        // Loop through each button and change its text
        buttons.forEach(function(button) {
            button.textContent = 'Store Details';
        });
    }
});





  // COLLECTION HORIZONTAL SCROLL


function initializeHorizontalScrollAnimation() {
    // Only initialize if the viewport is wider than 700px
    if(window.innerWidth > 700) {
        let container = document.querySelector(".collection-scroll-container");
        let wrapper = document.getElementById("scroll-wrapper");

        // Bail on pages without the horizontal-scroll section (e.g. Our Story) —
        // otherwise wrapper.scrollWidth throws on null.
        if (!container || !wrapper) return;

        // Define the horizontal scroll animation for the wrapper
        let scrollTween = gsap.to(wrapper, {
            x: () => -(wrapper.scrollWidth - document.documentElement.clientWidth) + "px",
            ease: "none",
            scrollTrigger: {
                trigger: container,
                start: "top top",
                end: () => "+=" + (wrapper.scrollWidth - document.documentElement.clientWidth) + "px",
                scrub: 1,
                pin: container,
                invalidateOnRefresh: true,
                anticipatePin: 1
            }
        });

        // Apply individual animations to each .collection-scroll-item
        gsap.utils.toArray(".collection-scroll-item").forEach(item => {
            gsap.to(item, {
                x: "-10%", // Adjust as needed
                ease: "none",
                scrollTrigger: {
                    trigger: item,
                    containerAnimation: scrollTween,
                    markers: false,
                    start: "left 10%",
                    end: "right 0%",
                    scrub: true
                }
            });
        });

        gsap.utils.toArray(".collection-scroll-item-content").forEach(content => {
            // Initially set the position to 20% to the right
            gsap.set(content, {x: "30%"});

            // Then create the animation to move from 20% right to -20% left
            gsap.to(content, {
                x: "-30%", // Target position to the left
                ease: "none",
                scrollTrigger: {
                    trigger: content,
                    containerAnimation: scrollTween,
                    markers: false,
                    start: "left 100%", // Begins when the content's left edge is at the right edge of the viewport
                    end: "right 0%", // Ends when the content's right edge has moved to the left edge of the viewport
                    scrub: true
                }
            });
        });  
    }
}

// Listen for DOM content loaded event to initialize the animation
document.addEventListener("DOMContentLoaded", function() {
    initializeHorizontalScrollAnimation();
});






  
  
  // FOOTER WHEEL



document.addEventListener('DOMContentLoaded', function() {
  // The wheel now lives in sections/m-footer.liquid and spins in CSS. This only
  // applies to the retired snippets/custom-footer.liquid markup, so bail when
  // that is not on the page rather than warn on every load.
  if (!document.querySelector('#Group_2_Wheel')) return;
  // Target Group 2 within the SVG for rotation using its ID
  gsap.to("#Group_2_Wheel", {
    rotation: 360, // Rotate the group 360 degrees
    transformOrigin: "50% 50%", // Sets the point around which transformations are applied
    duration: 80, // Duration of the animation in seconds
    ease: "none", // Use linear animation for continuous effect
    repeat: -1 // Repeat the animation indefinitely
  });
});




  // CONTACT WHEEL



  document.addEventListener('DOMContentLoaded', function() {
    // Check if the current URL path is /pages/contact
    if (window.location.pathname === '/pages/contact') {
      // Target the img within .image-with-text for rotation
      gsap.to(".image-with-text picture img", {
        rotation: 360, // Rotate the image 360 degrees
        duration: 80, // Duration of the animation in seconds
        ease: "none", // Use linear animation for continuous effect
        repeat: -1 // Repeat the animation indefinitely
      });
    }
  });


  





  // HOME PRELOADER


  document.addEventListener('DOMContentLoaded', function() {
  function adjustPreloadDisplay() {
    // Check if the current page is not the home page
    if (window.location.pathname !== "/") {
      // Select the single element with the class 'preload-container'
      var preloadContainer = document.querySelector('.preload-container');
      
      // If the element exists, set its display to 'none'
      if (preloadContainer) {
        preloadContainer.style.display = 'none';
      }
    }
  }

  // Call the function to adjust .preload-container display
  adjustPreloadDisplay();
});





  // NAV OPACITY



  document.addEventListener('DOMContentLoaded', function() {
  $('.header__primary-nav-item').hover(
    function() {
      $(this).addClass('hovered');
      $('.header__primary-nav-item').not($(this)).css('opacity', '0.5');
    },
    function() {
      $(this).removeClass('hovered');
      $('.header__primary-nav-item').css('opacity', '');
    }
  );
});

  document.addEventListener('DOMContentLoaded', function() {
  $('.link-faded').hover(
    function() {
      $(this).addClass('hovered');
      $('.link-faded').not($(this)).css('opacity', '0.5');
    },
    function() {
      $(this).removeClass('hovered');
      $('.link-faded').css('opacity', '');
    }
  );
});

  document.addEventListener('DOMContentLoaded', function() {
  $('.c-menu-item').hover(
    function() {
      $(this).addClass('hovered');
      $('.c-menu-item').not($(this)).css('opacity', '0.5');
    },
    function() {
      $(this).removeClass('hovered');
      $('.c-menu-item').css('opacity', '');
    }
  );
});






  // MULTIPLE MEDIA IMAGE REVERSE


  document.addEventListener('DOMContentLoaded', function() {
  $('.multiple-media-with-text--reverse').find('.test:nth-child(2) img').css('float', 'right');
});











  
document.addEventListener("DOMContentLoaded", function() {
  console.log("DOMContentLoaded event fired");


  // Existing parallax effect for .test:nth-child(2) elements
  document.querySelectorAll('.test:nth-child(2)').forEach(function(testElement) {
    ScrollTrigger.create({
      trigger: testElement,
      scrub: 0.8, // Adjusted value for smoother or more responsive animations
      start: "top bottom",
      end: "bottom top",
      onUpdate: self => {
        gsap.to(testElement, {
          y: `${self.progress * 50}px`,
          ease: "none"
        });
      }
    });
  });



  




  
});


// ========================================
// VIDEO 360-DRAG INTERACTION (DESKTOP)
// ========================================

(function() {
  'use strict';
  
  if (window.innerWidth <= 700) return; // Desktop only
  
  class Video360Controller {
    constructor(mediaElement) {
      this.mediaElement = mediaElement;
      this.videoElement = mediaElement.querySelector('video');
      
      if (!this.videoElement) return;
      
      this.isDragging = false;
      this.startX = 0;
      this.startTime = 0;
      this.dragSensitivity = 150; // Higher = slower rotation
      
      this.init();
    }
    
    init() {
      // Remove controls and set cursor
      this.videoElement.removeAttribute('controls');
      this.videoElement.controls = false;
      this.mediaElement.style.cursor = 'grab';
      
      this.addBadge();
      
      if (this.videoElement.readyState >= 2) {
        this.setupDragHandlers();
      } else {
        this.videoElement.addEventListener('loadedmetadata', () => {
          this.setupDragHandlers();
        });
      }
    }
    
    addBadge() {
      const badge = document.createElement('div');
      badge.className = 'video-360-badge';
      badge.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M2 12h20"></path>
        </svg>
        <span>Drag to Rotate</span>
      `;
      this.mediaElement.appendChild(badge);
    }
    
    setupDragHandlers() {
      this.mediaElement.addEventListener('mousedown', (e) => this.handleDragStart(e));
      document.addEventListener('mousemove', (e) => this.handleDragMove(e));
      document.addEventListener('mouseup', () => this.handleDragEnd());
      
      // Hover cursor handling
      this.mediaElement.addEventListener('mouseenter', () => {
        if (!this.isDragging) {
          this.mediaElement.style.cursor = 'grab';
        }
      });
      
      this.mediaElement.addEventListener('mouseleave', () => {
        if (!this.isDragging) {
          this.mediaElement.style.cursor = '';
        }
      });
      
      this.videoElement.addEventListener('click', (e) => {
        if (this.isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }
    
    handleDragStart(e) {
      this.isDragging = true;
      this.mediaElement.classList.add('is-dragging');
      this.mediaElement.style.cursor = 'grabbing';
      this.startX = e.clientX;
      this.startTime = this.videoElement.currentTime;
    }
    
    handleDragMove(e) {
      if (!this.isDragging) return;
      
      const deltaX = e.clientX - this.startX;
      const timeChange = (deltaX / this.dragSensitivity) * this.videoElement.duration;
      let newTime = this.startTime + timeChange;
      
      if (newTime < 0) {
        newTime = this.videoElement.duration + (newTime % this.videoElement.duration);
      } else if (newTime > this.videoElement.duration) {
        newTime = newTime % this.videoElement.duration;
      }
      
      this.videoElement.currentTime = newTime;
    }
    
    handleDragEnd() {
      if (!this.isDragging) return;
      
      this.isDragging = false;
      this.mediaElement.classList.remove('is-dragging');
      this.mediaElement.style.cursor = 'grab';
    }
  }
  
  function initVideo360() {
    const videoMediaElements = document.querySelectorAll('.product-gallery__media[data-media-type="video"]');
    
    videoMediaElements.forEach(mediaElement => {
      if (mediaElement.dataset.video360Initialized) return;
      
      const videoElement = mediaElement.querySelector('video');
      if (!videoElement) return;
      
      // Check if video has 360-drag in aria-label or alt text
      const ariaLabel = videoElement.getAttribute('aria-label') || '';
      const altText = videoElement.querySelector('img')?.getAttribute('alt') || '';
      
      const is360Video = ariaLabel.toLowerCase().includes('360-drag') || 
                        ariaLabel.toLowerCase().includes('360 drag') ||
                        altText.toLowerCase().includes('360-drag') ||
                        altText.toLowerCase().includes('360 drag');
      
      if (is360Video) {
        mediaElement.dataset.video360Initialized = 'true';
        new Video360Controller(mediaElement);
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideo360);
  } else {
    initVideo360();
  }
  
  document.addEventListener('variant:changed', initVideo360);
  
})();


// ========================================
// VIDEO 360-DRAG INTERACTION (MOBILE)
// ========================================

(function() {
  'use strict';
  
  if (window.innerWidth > 700) return; // Mobile only
  
  class MobileVideo360 {
    constructor(mediaElement) {
      this.mediaElement = mediaElement;
      this.videoElement = mediaElement.querySelector('video');
      
      if (!this.videoElement) return;
      
      this.isDragging = false;
      this.startX = 0;
      this.startTime = 0;
      this.dragSensitivity = 100; // Mobile sensitivity
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.isHorizontalDrag = null;
      
      this.carouselElement = this.mediaElement.closest('scroll-carousel');
      
      this.init();
    }
    
    init() {
      const badge = document.createElement('div');
      badge.className = 'video-360-badge';
      badge.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M2 12h20"></path>
        </svg>
        <span>Drag to Rotate</span>
      `;
      this.mediaElement.appendChild(badge);
      
      if (this.videoElement.readyState >= 2) {
        this.setupHandlers();
      } else {
        this.videoElement.addEventListener('loadedmetadata', () => this.setupHandlers());
      }
    }
    
    setupHandlers() {
      this.mediaElement.addEventListener('touchstart', (e) => this.handleStart(e), { passive: false, capture: true });
      document.addEventListener('touchmove', (e) => this.handleMove(e), { passive: false, capture: true });
      document.addEventListener('touchend', (e) => this.handleEnd(e), { passive: false, capture: true });
      document.addEventListener('touchcancel', (e) => this.handleEnd(e), { passive: false, capture: true });
    }
    
    handleStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.isHorizontalDrag = null;
      this.isDragging = true;
      this.startX = this.touchStartX;
      this.startTime = this.videoElement.currentTime;
    }
    
    handleMove(e) {
      if (!this.isDragging) return;
      
      const clientX = e.touches[0].clientX;
      const clientY = e.touches[0].clientY;
      
      if (this.isHorizontalDrag === null) {
        const deltaX = Math.abs(clientX - this.touchStartX);
        const deltaY = Math.abs(clientY - this.touchStartY);
        
        if (deltaX > deltaY && deltaX > 15) {
          this.isHorizontalDrag = true;
          this.mediaElement.classList.add('is-dragging-mobile');
          
          if (this.carouselElement) {
            this.carouselElement.style.overflowX = 'hidden';
          }
          
          e.stopPropagation();
          e.preventDefault();
        } else if (deltaY > deltaX && deltaY > 15) {
          this.isHorizontalDrag = false;
          this.handleEnd();
          return;
        } else {
          return;
        }
      }
      
      if (this.isHorizontalDrag) {
        e.stopPropagation();
        e.preventDefault();
      }
      
      if (!this.isHorizontalDrag) return;
      
      const deltaX = clientX - this.startX;
      const timeChange = (deltaX / this.dragSensitivity) * this.videoElement.duration;
      let newTime = this.startTime + timeChange;
      
      if (newTime < 0) {
        newTime = this.videoElement.duration + (newTime % this.videoElement.duration);
      } else if (newTime > this.videoElement.duration) {
        newTime = newTime % this.videoElement.duration;
      }
      
      this.videoElement.currentTime = newTime;
    }
    
    handleEnd(e) {
      if (!this.isDragging) return;
      
      if (e && this.isHorizontalDrag) {
        e.stopPropagation();
      }
      
      if (this.carouselElement) {
        this.carouselElement.style.overflowX = '';
      }
      
      this.isDragging = false;
      this.isHorizontalDrag = null;
      this.mediaElement.classList.remove('is-dragging-mobile');
    }
  }
  
  function initMobile360() {
    if (window.innerWidth > 700) return;
    
    const videos = document.querySelectorAll('.product-gallery__media[data-media-type="video"]');
    
    videos.forEach(media => {
      if (media.dataset.mobile360Init) return;
      
      const video = media.querySelector('video');
      if (!video) return;
      
      const ariaLabel = video.getAttribute('aria-label') || '';
      const altText = video.querySelector('img')?.getAttribute('alt') || '';
      
      const is360 = ariaLabel.toLowerCase().includes('360-drag') || 
                   ariaLabel.toLowerCase().includes('360 drag') ||
                   altText.toLowerCase().includes('360-drag') ||
                   altText.toLowerCase().includes('360 drag');
      
      if (is360) {
        media.dataset.mobile360Init = 'true';
        new MobileVideo360(media);
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobile360);
  } else {
    initMobile360();
  }
  
  document.addEventListener('variant:changed', initMobile360);
  
})();


// ========================================
// ENSURE RING SIZE PROPERTIES ARE INCLUDED IN CART
// Safety net: Ensures ring size properties are included even if form attribute fails
// The Liquid template should handle form attribute, but this provides a fallback
// ========================================

(function() {
  'use strict';
  
  // Function to add ring size properties to FormData
  function addRingSizeProperties(form, formData) {
    const productInfo = form.closest('.product-info');
    if (!productInfo) return;
    
    // Find ring size inputs in the same product-info block
    const ringSizeInputs = productInfo.querySelectorAll(
      'input[name="properties[Ring Size]"]'
    );
    
    // Find the checked radio button
    let checkedInput = null;
    ringSizeInputs.forEach(input => {
      if (!input.disabled && input.type === 'radio' && input.checked) {
        checkedInput = input;
      }
    });
    
    // Add the property to FormData if we found a checked input
    if (checkedInput) {
      const value = checkedInput.value || '';
      formData.set('properties[Ring Size]', value);
    }
  }
  
  // Intercept fetch calls to cart/add.js as a safety net
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    const options = args[1] || {};
    
    // Check if this is a cart/add.js request with FormData
    if (typeof url === 'string' && url.includes('/cart/add.js') && options.body instanceof FormData) {
      const formData = options.body;
      const variantId = formData.get('id');
      
      // Check if ring size is already in FormData
      if (!formData.has('properties[Ring Size]')) {
        // Find the product form that triggered this submission
        const productForms = document.querySelectorAll('product-form');
        
        for (const productForm of productForms) {
          const form = productForm.querySelector('form');
          if (!form || !form.id) continue;
          
          // Match form by variant ID
          if (variantId) {
            const formVariantInput = form.querySelector('input[name="id"]');
            if (formVariantInput && formVariantInput.value === variantId.toString()) {
              addRingSizeProperties(form, formData);
              break;
            }
          }
        }
      }
    }
    
    // Call original fetch
    return originalFetch.apply(this, args);
  };

})();

/**
 * Product card hover-video controller.
 * Plays/pauses the video on hover, supports touch + drag-to-scrub, and
 * watches for AJAX-loaded cards. Reads `data-video-hover` and
 * `data-disable-video-mobile` from the surrounding collection section.
 */
class ProductCardVideoHover {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    const sectionEl = document.querySelector('.shopify-section--main-collection')
      || document.querySelector('.shopify-section--related-products')
      || document.body;

    const videoHoverEnabled = sectionEl.getAttribute?.('data-video-hover') !== 'false';
    const disableOnMobile = sectionEl.getAttribute?.('data-disable-video-mobile') === 'true';

    if (!videoHoverEnabled) return;
    if (disableOnMobile && this.isMobileDevice()) return;

    document.querySelectorAll('.product-card__media').forEach(card => {
      const videoContainer = card.querySelector('.product-card__video-container');
      if (videoContainer) this.setupCardHover(card, videoContainer);
    });

    this.observeNewCards();
  }

  isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      window.innerWidth <= 768;
  }

  setupCardHover(card, videoContainer) {
    const video = videoContainer.querySelector('video');
    const iframe = videoContainer.querySelector('iframe');

    card.addEventListener('mouseenter', () => {
      this.handleMouseEnter(video, iframe, videoContainer);
    });

    card.addEventListener('mouseleave', () => {
      this.handleMouseLeave(video, iframe);
      if (video) {
        try { video.play(); } catch (_) {}
      }
    });

    const sectionEl = document.querySelector('.shopify-section--main-collection')
      || document.querySelector('.shopify-section--related-products')
      || document.body;
    const disableOnMobile = sectionEl?.getAttribute?.('data-disable-video-mobile') === 'true';

    if (!disableOnMobile) {
      card.addEventListener('touchstart', () => {
        this.handleMouseEnter(video, iframe, videoContainer);
      }, { passive: true });
    }

    if (video) this.prepareVideo(video);

    // Drag-to-scrub
    let isPointerDown = false;
    let rafId = null;
    let pendingTime = null;

    const computeTimeFromEvent = (evt) => {
      if (!video) return 0;
      const rect = card.getBoundingClientRect();
      let clientX = evt.clientX;
      if (evt.touches && evt.touches.length) clientX = evt.touches[0].clientX;
      const x = Math.max(0, Math.min(rect.width, clientX - rect.left));
      const frac = rect.width > 0 ? x / rect.width : 0;
      const dur = (video && isFinite(video.duration)) ? video.duration : 0;
      return dur * frac;
    };

    const applyTime = () => {
      if (pendingTime == null || !video) return;
      try { video.currentTime = Math.max(0, Math.min(video.duration || 0, pendingTime)); } catch (_) {}
      pendingTime = null;
      rafId = null;
    };

    const scheduleApplyTime = () => {
      if (rafId == null) rafId = requestAnimationFrame(applyTime);
    };

    card.addEventListener('mousedown', (e) => {
      if (!video) return;
      isPointerDown = true;
      e.preventDefault();
      try { video.pause(); } catch (_) {}
      pendingTime = computeTimeFromEvent(e);
      scheduleApplyTime();
    });

    window.addEventListener('mousemove', (e) => {
      if (!isPointerDown || !video) return;
      e.preventDefault();
      pendingTime = computeTimeFromEvent(e);
      scheduleApplyTime();
    }, { passive: false });

    window.addEventListener('mouseup', () => { isPointerDown = false; });

    window.addEventListener('touchmove', (e) => {
      if (!isPointerDown || !video) return;
      e.preventDefault();
      pendingTime = computeTimeFromEvent(e);
      scheduleApplyTime();
    }, { passive: false });

    window.addEventListener('touchend', () => { isPointerDown = false; });
    window.addEventListener('touchcancel', () => { isPointerDown = false; });
  }

  handleMouseEnter(video, iframe, videoContainer) {
    if (video) this.playNativeVideo(video);
    else if (iframe) this.playExternalVideo(iframe);
  }

  handleMouseLeave(video, iframe) {
    if (video) this.pauseNativeVideo(video);
    else if (iframe) this.pauseExternalVideo(iframe);
  }

  prepareVideo(video) {
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.controls = false;
    video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
    video.setAttribute('disablepictureinpicture', '');

    video.addEventListener('loadeddata', () => video.setAttribute('data-loading', 'false'));
    video.addEventListener('loadstart', () => video.setAttribute('data-loading', 'true'));
  }

  async playNativeVideo(video) {
    try {
      video.currentTime = 0;
      const playPromise = video.play();
      if (playPromise !== undefined) await playPromise;
    } catch (error) {
      console.log('Video autoplay was prevented:', error);
    }
  }

  pauseNativeVideo(video) {
    try {
      video.pause();
      video.currentTime = 0;
    } catch (error) {
      console.log('Error pausing video:', error);
    }
  }

  playExternalVideo(iframe) {
    if (iframe.src.includes('youtube.com') || iframe.src.includes('youtu.be')) {
      this.handleYouTubeVideo(iframe, 'play');
    } else if (iframe.src.includes('vimeo.com')) {
      this.handleVimeoVideo(iframe, 'play');
    }
  }

  pauseExternalVideo(iframe) {
    if (iframe.src.includes('youtube.com') || iframe.src.includes('youtu.be')) {
      this.handleYouTubeVideo(iframe, 'pause');
    } else if (iframe.src.includes('vimeo.com')) {
      this.handleVimeoVideo(iframe, 'pause');
    }
  }

  handleYouTubeVideo(iframe, action) {
    try {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: action === 'play' ? 'playVideo' : 'pauseVideo'
      }), '*');
    } catch (error) {
      console.log('Error controlling YouTube video:', error);
    }
  }

  handleVimeoVideo(iframe, action) {
    try {
      iframe.contentWindow.postMessage(JSON.stringify({
        method: action === 'play' ? 'play' : 'pause'
      }), '*');
    } catch (error) {
      console.log('Error controlling Vimeo video:', error);
    }
  }

  observeNewCards() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const sectionEl = document.querySelector('.shopify-section--main-collection')
              || document.querySelector('.shopify-section--related-products')
              || document.body;
            const videoHoverEnabled = sectionEl?.getAttribute?.('data-video-hover') !== 'false';
            const disableOnMobile = sectionEl?.getAttribute?.('data-disable-video-mobile') === 'true';

            if (!videoHoverEnabled || (disableOnMobile && this.isMobileDevice())) return;

            const newCards = node.querySelectorAll
              ? node.querySelectorAll('.product-card__media')
              : [];
            newCards.forEach(card => {
              const videoContainer = card.querySelector('.product-card__video-container');
              if (videoContainer) this.setupCardHover(card, videoContainer);
            });
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  disable() { document.body.style.setProperty('--video-hover-disabled', '1'); }
  enable() { document.body.style.removeProperty('--video-hover-disabled'); }
}

const productCardVideoHover = new ProductCardVideoHover();
window.ProductCardVideoHover = ProductCardVideoHover;

/**
 * Make the Nutshell reviews "Google Rating" header block clickable → opens
 * Olivia Green's Google Maps page (Reviews tab) in a new tab. URL is the
 * exact place-link Google uses, with the `!1b1` flag that lands on the
 * Reviews tab and the trailing analytics query string stripped.
 */
(function googleRatingLink() {
  const URL = 'https://www.google.com/maps/place/Olivia+Green/@53.961498,-1.0848384,17z/data=!4m16!1m9!3m8!1s0x4879312aded8c65f:0x88c1aed3334e8a23!2sOlivia+Green!8m2!3d53.961498!4d-1.0822635!9m1!1b1!16s%2Fg%2F11w1zy186f!3m5!1s0x4879312aded8c65f:0x88c1aed3334e8a23!8m2!3d53.961498!4d-1.0822635!16s%2Fg%2F11w1zy186f';

  function bind() {
    document.querySelectorAll('[class*="Nutshell__StyledFoundation"] [class*="Header__Container"]').forEach((el) => {
      if (el.dataset.googleRatingLinked) return;
      el.dataset.googleRatingLinked = 'true';
      el.style.cursor = 'pointer';
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Read our Google reviews (opens in a new tab)');

      const open = () => window.open(URL, '_blank', 'noopener,noreferrer');
      el.addEventListener('click', open);
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      });
    });
  }

  // The Nutshell app loads async — bind on DOM ready and re-check a couple
  // of times so we catch the moment its header markup arrives.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  setTimeout(bind, 1500);
  setTimeout(bind, 4000);
})();


// Ring Customisation add-ons (variants of the hidden ring-customisation product, tied to their
// ring via the "For" property). Removing a ring must take its add-ons with it — in ONE cart
// request, so the drawer/cart re-render once (two rapid cart:change events race in the theme's
// async replaceContent and the drawer can end up showing stale content).
(function () {
  var HANDLE = 'ring-customisation';
  var busy = false;
  /* Same rule as snippets/addon-belongs.liquid: For = ring title, and a Ring size add-on also
     needs the ring's Ring Size, so one band in two sizes keeps each charge with its ring. */
  function belongs(addon, ring) {
    var ap = addon.properties || {};
    var rp = ring.properties || {};
    return ap['For'] === ring.product_title && (!ap['Ring Size'] || ap['Ring Size'] === rp['Ring Size']);
  }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function bundledSections() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    return sections;
  }

  function updateAndNotify(updates) {
    var sections = bundledSections();
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sections.join(',') })
    }).then(function (r) { return r.json(); }).then(function (newCart) {
      if (!sections.length) { window.location.reload(); return; }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'line-item:change', cart: newCart }
      }));
      /* The theme's async replaceContent doesn't reliably repaint here — patch the drawer
         DOM directly with the same section HTML (idempotent with the theme's own handler). */
      var drawer = document.querySelector('cart-drawer');
      var key = Object.keys(newCart.sections || {}).find(function (k) { return k.indexOf('cart-drawer') > -1; });
      if (drawer && key && newCart.sections[key]) {
        var fresh = new DOMParser().parseFromString(newCart.sections[key], 'text/html').querySelector('cart-drawer');
        if (fresh) {
          drawer.replaceChildren.apply(drawer, Array.prototype.slice.call(fresh.childNodes));
          drawer.classList.toggle('drawer--center-body', newCart.item_count === 0);
        }
      }
    });
  }

  /* Removal links: if the removed line is a ring with add-ons, zero them all in one request.
     Capture phase + stopPropagation so the theme's own handler doesn't double-process. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="/cart/change"]');
    if (!link || busy) return;
    var url;
    try { url = new URL(link.href, location.origin); } catch (err) { return; }
    if (url.searchParams.get('quantity') !== '0') return;
    var lineKey = url.searchParams.get('id');
    if (!lineKey) return;
    e.preventDefault();
    e.stopPropagation();
    busy = true;
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var target = cart.items.find(function (i) { return i.key === lineKey; });
        var updates = {};
        updates[lineKey] = 0;
        if (target && target.handle !== HANDLE) {
          cart.items.forEach(function (i) {
            if (i.handle === HANDLE && belongs(i, target)) updates[i.key] = 0;
          });
        }
        return updateAndNotify(updates);
      })
      .then(function () { busy = false; })
      .catch(function () { busy = false; window.location.href = link.href; });
  }, true);

  /* Backstop for removals that bypass the links (e.g. quantity stepper to 0):
     drop orphaned add-ons whose ring is gone. */
  document.addEventListener('cart:change', function (e) {
    if (busy) return;
    setTimeout(function () {
      if (busy) return;
      fetch(root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var rings = cart.items.filter(function (i) { return i.handle !== HANDLE; });
          var updates = {};
          cart.items.forEach(function (i) {
            if (i.handle !== HANDLE) return;
            if (!rings.some(function (r) { return belongs(i, r); })) updates[i.key] = 0;
          });
          if (!Object.keys(updates).length) return;
          busy = true;
          return updateAndNotify(updates).then(function () { busy = false; });
        })
        .catch(function () { busy = false; });
    }, 100);
  });
})();
